{
    "ENV": {
        "TITLE": "Werkbaarbeter | Development",
        "API": "https://dev.api.werkbaarbeter.net",
        "WEBSOCKET": "",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "4d819eaf-68ef-474f-802d-b842dd0c1658",
        "MSAL_TENANT_ID": "6137e509-173d-4076-afc4-67b476042cf9",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "false",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": "true",
        "EMAIL_LOGIN": "",
        "HIDE_PRIVATE_EMAIL_CHECKBOX": ""
    }
}